<template>
  <section
    class="pt-[137px] pb-5 max-[1199px]:pt-[55px] max-[1199px]:pb-5 md:pb-[124px] min-[1200px]:pb-[178px]"
  >
    <div class="mx-auto w-full max-w-container flex justify-center">
      <Card variant="landing" class="max-w-6xl mx-9 md:mx-0">
        <h2 v-if="title" class="landing_h2 text-center" v-html="title" />
        <h2 v-else class="landing_h2 text-center">
          <Translate translate-key="index_page.landingBoostCreditData.title" />
        </h2>
        <div
          v-if="text"
          class="mx-auto mb-10 max-w-2xl text-center text-base leading-relaxed text-gray-700 prose prose-gray max-w-none prose-p:mb-2 prose-p:last:mb-0 prose-strong:font-semibold"
          v-html="text"
        />
        <p
          v-else
          class="mx-auto mb-10 max-w-2xl text-center text-base leading-relaxed text-gray-700"
        >
          <Translate translate-key="index_page.landingBoostCreditData.text" />
        </p>
        <div class="flex justify-center">
          <Button
            v-if="!userStore.isAuthenticated"
            id="getStartedImproveScoreToday"
            as="a"
            :href="linkHref('/signup?type=buyer')"
            variant="landing1"
            size="xl"
          >
            <Translate translate-key="landing_boost_credit.get_started" />
          </Button>
          <Button
            v-else-if="userStore.isCardholder"
            id="getStartedImproveScoreToday"
            :as="NuxtLink"
            variant="landing1"
            size="xl"
            to="/cardholder/card"
            class="font-bold"
          >
            <Translate translate-key="landing_boost_credit.get_started" />
          </Button>
          <Button
            v-else
            id="getStartedImproveScoreToday"
            as="a"
            :href="linkHref('/tradelines-for-sale?limit=50&offset=0')"
            variant="landing1"
            size="xl"
            class="font-bold"
          >
            <Translate translate-key="landing_boost_credit.get_started" />
          </Button>
        </div>
      </Card>
    </div>
  </section>
</template>

<script setup lang="ts">
import { NuxtLink } from "#components";
import { Button } from "~/shared/components/ui/button";
import { Card } from "~/shared/components/ui/card";
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { useCurrentUserStore } from "~/stores/userStore";

withDefaults(
  defineProps<{
    /** When set, overrides the default index page title (e.g. "Get Your Personal Tradelines Right Now") */
    title?: string;
    /** When set, overrides the default index page text; supports HTML */
    text?: string;
  }>(),
  { title: "", text: "" },
);

const userStore = useCurrentUserStore();
const { linkHref } = useNativeRouteLink();
</script>
